import React from "react";
import { Redirect } from "react-router-dom";
import { ACCOUNT_HOME } from "../../components/account/accountNavItems";

/*
    /main/setting was the settings page for the life of the site, so it is in
    bookmarks, in old emails and in anything anyone has linked. It now sends
    people to My Details, the default settings page.

    A redirect rather than a deletion: a 404 for a URL we used to serve is a
    worse answer than a slightly stale link.
*/
const LegacySettingRedirect = () => <Redirect to={ACCOUNT_HOME} />;

export default LegacySettingRedirect;
